import EditPayments from './EditPayments';
export default EditPayments;
